export default "__VITE_ASSET__C8_zPjC0__"